<template>
  <v-card id="calendar" class="mb-5">
    <v-card-title v-if="!hideTitle">
      <div class="d-flex align-center">
        <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('calendar')" color="white">
          <v-icon>
            mdi-dots-vertical
          </v-icon>
        </v-btn>
        <h2>
          Календарь пациента {{ $date(calendarDates.start).format("D MMMM") }} - {{ $date(calendarDates.end).format("D MMMM") }}
        </h2>
      </div>
    </v-card-title>

    <div v-if="isShow">
      <v-sheet tile height="54" color="grey lighten-3" class="d-flex align-center">
        <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        {{ previousButtonTitle }}
        <v-spacer></v-spacer>

        <v-btn-toggle v-model="type" mandatory borderless tile background-color="transparent">
          <v-btn v-for="(itemType, idx) in types" :key="itemType.value + idx" :value="itemType.value" text>
            {{ itemType.text }}
          </v-btn>
        </v-btn-toggle>

        <v-spacer></v-spacer>
        {{ nextButtonTitle }}

        <v-btn icon class="ma-2" @click="$refs.calendar.next()">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-sheet>

      <v-sheet height="600" class="position-relative">
        <div class="loader" v-if="loading">
          <v-progress-circular :size="50" color="primary" indeterminate class="c-loader" />
        </div>

        <v-calendar
          ref="calendar"
          locale="ru"
          :short-weekdays="false"
          :weekdays="weekday"
          :type="type"
          :events="events"
          :event-overlap-mode="mode"
          :event-overlap-threshold="30"
          :event-color="getEventColor"
          v-model="value"
          @change="getEvents"
          @click:more="showDay"
          @click:date="showDay"
          @click:event="showEvent"
        >
          <template #day="{ date }">
            <div :data-date="date"></div>
            <v-btn color="primary" class="add-event" fab x-small v-if="CURRENT_DATE.isSameOrBefore(date)" @click="addEvent(date)">
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <template #day-header="{ date }">
            <div :data-date="date"></div>
          </template>
          <template #event="props">
            <!-- {{ props }} -->
            <div
              :id="`event-${props.eventParsed.input.id}`"
              @mouseenter="builtTooltip(props.eventParsed)"
              @mouseleave="destroyTooltip()"
              class="px-1"
            >
              <span
                ><b>{{ props.eventParsed.start.time }}</b> {{ props.eventParsed.input.name }}</span
              >
              <span v-if="props.eventParsed.input.status === 'finished'"> (завершен)</span>
            </div>
            <div
              v-if="props.eventParsed.input.type === 'appointment_doctor'"
              :id="`event-content-${props.eventParsed.input.id}`"
              class="event-content"
              @mouseenter="builtTooltip(props.eventParsed)"
              @mouseleave="destroyTooltip()"
            >
              <span
                ><b>{{ props.eventParsed.start.time }}</b> {{ props.eventParsed.input.name }} </span
              ><br />

              <div v-if="props.eventParsed.input.doctor && props.eventParsed.input.doctor.name">
                {{ props.eventParsed.input.doctor.name }}
              </div>
              <div
                v-if="
                  props.eventParsed.input.doctor &&
                    props.eventParsed.input.doctor.specializations &&
                    props.eventParsed.input.doctor.specializations.length
                "
              >
                {{ props.eventParsed.input.doctor.specializations.join(", ") }}
              </div>
            </div>
          </template>
        </v-calendar>
      </v-sheet>
    </div>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import SelectModalType from "./SelectModalType.vue";
import { mapMutations, mapState } from "vuex";
import { CustomerService } from "@/services/api/customer.service";
import { ScheduleRepository } from "@/modules/schedule/schedule.repository.js";
import ScheduleAppointmentDetail from "@/modules/schedule/ScheduleAppointmentDetail.vue";
import Tether from "tether";

dayjs.extend(customParseFormat);

export default {
  name: "Calendar",

  components: {},

  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    loading: false,
    showPopper: null,
    value: dayjs().format("YYYY-MM-DD"),
    CURRENT_DATE: dayjs().startOf("day"),
    type: "month",
    types: [
      { text: "Месяц", value: "month" },
      { text: "Неделя", value: "week" },
      { text: "День", value: "day" },
    ],
    mode: "stack",
    modes: ["stack", "column"],
    weekday: [1, 2, 3, 4, 5, 6, 0],
    colors: ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"],
    calendarDates: {
      start: dayjs()
        .startOf("month")
        .subtract(1, "week")
        .format("YYYY-MM-DD"),
      end: dayjs()
        .endOf("month")
        .add(1, "week")
        .format("YYYY-MM-DD"),
    },
  }),

  computed: {
    ...mapState("ikp", ["closedBlocks"]),
    isShow() {
      return !this.closedBlocks.includes("calendar");
    },
    isDoctorViewer() {
      return this.$store.state.auth.profile?.is_doctor;
    },
    customerId() {
      return this.$store.state.customer.id;
    },

    events() {
      return this.$store.state.ikp.calendar;
    },
    doctorId() {
      return this.$store.state.auth.id;
    },
    previousButtonTitle() {
      if (this.type === "month") {
        return this.$date(this.calendarDates.start)
          .subtract("1", "month")
          .format("MMMM");
      } else if (this.type === "week") {
        return (
          this.$date(this.calendarDates.start)
            .subtract("1", "week")
            .startOf("week")
            .format("DD MMM") +
          " - " +
          this.$date(this.calendarDates.start)
            .subtract("1", "week")
            .endOf("week")
            .format("DD MMM")
        );
      } else if (this.type === "day") {
        return this.$date(this.calendarDates.start)
          .subtract("1", "days")
          .format("dd, DD");
      }

      return "Предыдущий период";
    },
    nextButtonTitle() {
      if (this.type === "month") {
        return this.$date(this.calendarDates.end)
          .add("1", "month")
          .format("MMMM");
      } else if (this.type === "week") {
        return (
          this.$date(this.calendarDates.end)
            .add("1", "week")
            .startOf("week")
            .format("DD MMM") +
          " - " +
          this.$date(this.calendarDates.end)
            .add("1", "week")
            .endOf("week")
            .format("DD MMM")
        );
      } else if (this.type === "day") {
        return this.$date(this.calendarDates.end)
          .add("1", "days")
          .format("dd, DD");
      }

      return "Предыдущий период";
    },
  },

  //   async mounted() {
  //   if (this.isDoctorViewer) {
  //     await this.loadEventsByDoctor();
  //   } else {
  //     await this.loadEventsByCustomer();
  //   }
  //   },

  methods: {
    builtTooltip(data) {
      if (data.input.type === "appointment_doctor") {
        this.currentEvent = data;

        this.tether = new Tether({
          element: document.querySelector(`#event-content-${data.input.id}`),
          target: document.querySelector(`#event-${data.input.id}`),
          attachment: "bottom left",
          targetAttachment: "top left",
        });
        this.tether.position();
      }
    },
    destroyTooltip() {
      if (this.tether) {
        this.tether.destroy();
      }
    },
    ...mapMutations("ikp", ["SET_CALENDAR", "TOGGLE_CLOSED_BLOCK"]),

    // async loadEventsByDoctor() {
    //   try {
    //     const response = await this.$http.get("/v1/doctor/appointments");
    //     const responseEvents = (response.data?.data || []).map(el => {
    //       return {
    //         title: "приём",
    //         start: dayjs(el.start_at, "DD.MM.YYYY HH:mm").format("YYYY-MM-DD HH:mm"),
    //         end: null,
    //         all_day: false,
    //         originalEvent: el,
    //       };
    //     });
    //     this.SET_CALENDAR([...responseEvents, ...this.events]);
    //   } catch (error) {
    //     this.$dialog.notify.error("Ошибка получения данных");
    //   }
    // },

    // async loadEventsByCustomer() {
    //   try {
    //     const response = await this.$http.get("/v1/customer/appointments");
    //     const responseEvents = (response.data?.data || []).map(el => {
    //       return {
    //         title: "приём",
    //         start: dayjs(el.start_at, "DD.MM.YYYY HH:mm").format("YYYY-MM-DD HH:mm"),
    //         end: null,
    //         all_day: false,
    //         originalEvent: el,
    //       };
    //     });
    //     this.SET_CALENDAR([...responseEvents, ...this.events]);
    //   } catch (error) {
    //     this.$dialog.notify.error("Ошибка получения данных");
    //   }
    // },

    async getEvents(dateRange) {
      this.loading = true;

      this.calendarDates.start = dayjs(dateRange.start.date).format("YYYY-MM-DD");
      this.calendarDates.end = dayjs(dateRange.end.date).format("YYYY-MM-DD");

      await this.$store.dispatch("ikp/loadEvents", this.calendarDates);

      this.loading = false;
    },

    /**
     * Для установки цвета евента.
     * Можно динамически расчитывать цвет ивента.
     * По умолчанию возврааем дефолтный цвет из объекта ивента
     *
     * @param event
     * @return {*}
     */
    getEventColor(event) {
      if (this.CURRENT_DATE.isSameOrBefore(event.start)) {
        return "blue";
      }

      return "grey darken-1";
    },

    /**
     * Обработка клика по ивенту
     *
     * @param nativeEvent
     * @param event
     */
    async showEvent({ nativeEvent, event }) {
      console.log(event);

      nativeEvent.stopPropagation();
      // показываем документ
      console.log(`event =>`, event);
      if (event.doc_id) {
        try {
          const r = await CustomerService.getDocument(this.customerId, event.doc_id);

          await this.$dialog.showAndWait(AddDocument, {
            customerForm: r,
            readonly: false,
            width: 600,
            doctorId: this.doctorId,
            documentId: event.doc_id,
            appointmentId: event.appointment_id,
            persistent: true,
          });
          this.loading = true;
          await this.$store.dispatch("ikp/loadEvents", this.calendarDates);
          this.loading = false;
        } catch (e) {
          if (e?.response.status === 404) {
            this.$dialog.notify.error(`Документ №${event.doc_id} не найден`);
          } else {
            this.$dialog.notify.error("Не удалось загрузить документ");
          }
        }
        return;
      }
      if (event.entity_id) {
        if (event.type === "appointment_doctor") {
          // показать данные записи на прием
          const data = await ScheduleRepository.getAppointment(event.entity_id);
          if (data.success) {
            await this.$dialog.showAndWait(ScheduleAppointmentDetail, {
              width: "600px",
              appointment: data.data,
              calendarEvent: event,
            });
            this.loading = true;
            await this.$store.dispatch("ikp/loadEvents", this.calendarDates);
            this.loading = false;
          } else {
            this.$dialog.notify.error(data.message);
          }
        }
      }
    },

    async addEvent(date) {
      await this.$dialog.showAndWait(SelectModalType, { width: "600px", date: date });
      this.loading = true;
      await this.$store.dispatch("ikp/loadEvents", this.calendarDates);
      this.loading = false;
    },

    showDay({ date }) {
      this.value = date;
      this.type = "day";
    },
  },
};
</script>

<style lang="scss">
.event-content {
  line-height: 1.6;
  font-family: Roboto;
  pointer-events: none;
  transition: none;
  opacity: 0;
  animation: fadeOut 0.3s ease-in;
  padding: 8px;
  background: #363636;
  color: #fff;
  border-radius: 4px;
  width: 250px;
  z-index: 100;
  &.tether-enabled {
    animation: fadeIn 0.3s ease-in forwards;
  }
}
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
#calendar {
  .add-event {
    position: absolute;
    right: 5px;
    bottom: 5px;
    z-index: 100;
  }
  .loader {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgb(255 255 255 / 60%);
    z-index: 101;
  }
}
</style>
